import { render, staticRenderFns } from "./ProdutoTabela.vue?vue&type=template&id=76f2bc14&lang=html"
import script from "./ProdutoTabela.vue?vue&type=script&lang=js"
export * from "./ProdutoTabela.vue?vue&type=script&lang=js"
import style0 from "./ProdutoTabela.vue?vue&type=style&index=0&id=76f2bc14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports